export default __webpack_public_path__ + "static/media/parking.01b7a58c.svg";